import { getFillByLot } from "../manzanas/Manzana2Div1";

export const Manzana23Div1M2 = ({
  lands,
  landSelector = (_e, _id) => {},
  selected,
  style,
}) => {
  const findLandByLot = (lot) => {
    return lands.filter((l) => l.lote === lot)[0];
  };

  if (!lands) {
    return <></>;
  }

  return (
    <svg 
    width={style?.width || "1219"}
    height={style?.height || "941"}
    viewBox="0 0 1221 921" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg">
    <rect width="1221" height="921" fill="url(#pattern0_1467_38253)"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("1"))}      
      d="M730.468 339.158V376.903L671.39 381.826L666.466 327.671L704.211 322.748L730.468 339.158Z" 
      fill={getFillByLot(1, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("21"))}      
      d="M723.899 417.93L730.464 376.904L658.257 383.468L661.539 437.623C672.479 437.076 698.627 435.654 709.13 434.341C719.633 433.028 723.352 422.854 723.899 417.93Z" 
      fill={getFillByLot(21, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("20"))}      
      d="M599.177 447.468L661.538 437.622L658.255 383.466L612.306 390.031L590.972 394.954L599.177 447.468Z" 
      fill={getFillByLot(20, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("2"))}      
      d="M605.74 335.877L666.459 327.671L671.382 381.827L612.304 390.032L605.74 335.877Z" 
      fill={getFillByLot(2, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("3"))}      
      d="M543.381 349.005L605.742 335.876L612.306 390.031L554.869 403.16L543.381 349.005Z" 
      fill={getFillByLot(3, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("19"))}      
      d="M538.457 460.596L599.176 447.468L590.971 394.954L525.328 411.364L538.457 460.596Z" 
      fill={getFillByLot(19, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("4"))}      
      d="M484.302 365.413L543.381 349.002L554.868 403.158L497.431 417.927L484.302 365.413Z" 
      fill={getFillByLot(4, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("18"))}      
      d="M477.743 480.289L538.462 460.596L525.334 411.364L461.332 429.416L477.743 480.289Z" 
      fill={getFillByLot(18, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("5"))}      
      d="M425.223 383.468L484.301 365.417L497.43 417.931L441.633 435.982L425.223 383.468Z" 
      fill={getFillByLot(5, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("17"))}      
      d="M417.02 501.62L477.739 480.287L461.329 429.414L397.327 452.389L417.02 501.62Z" 
      fill={getFillByLot(17, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("6"))}      
      d="M367.79 404.8L425.227 383.466L441.638 435.98L385.842 457.314L367.79 404.8Z" 
      fill={getFillByLot(6, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("16"))}      
      d="M359.586 527.88L417.024 501.623L397.331 452.391L336.611 478.648L359.586 527.88Z" 
      fill={getFillByLot(16, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("7"))}      
      d="M310.351 431.058L367.788 404.801L385.84 457.315L333.326 480.29L310.351 431.058Z" 
      fill={getFillByLot(7, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("15"))}      
      d="M303.788 555.781L359.585 527.882L336.61 478.65L277.531 508.19L303.788 555.781Z" 
      fill={getFillByLot(15, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("8"))}      
      d="M256.193 458.955L310.349 431.057L333.323 480.289L280.809 506.546L256.193 458.955Z" 
      fill={getFillByLot(8, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("9"))}      
      d="M203.686 485.215L256.2 458.958L280.816 506.548L228.302 534.447L203.686 485.215Z" 
      fill={getFillByLot(9, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("14"))}      
      d="M244.711 588.599L303.789 555.777L277.532 508.187L220.095 539.367L244.711 588.599Z" 
      fill={getFillByLot(14, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("13"))}      
      d="M188.91 618.14L244.707 588.601L220.091 539.369L162.653 568.908L188.91 618.14Z" 
      fill={getFillByLot(13, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("10"))}      
      d="M149.523 513.111L203.679 485.212L228.295 534.444L174.139 562.343L149.523 513.111Z" 
      fill={getFillByLot(10, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("11"))}      
      d="M106.857 534.444L149.525 513.11L174.141 562.342L111.781 593.522L106.857 534.444Z" 
      fill={getFillByLot(11, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <path 
      className="cursor-pointer"
      onClick={(e) => landSelector(e, findLandByLot("12"))}      
      d="M133.112 647.676L188.908 618.137L162.651 568.905L111.778 593.521L115.06 639.471C120.312 647.348 129.283 648.223 133.112 647.676Z" 
      fill={getFillByLot(12, selected, lands)} 
      fill-opacity="0.64" 
      stroke="#6D6859" 
      stroke-opacity="0.6"/>
    <defs>
    <pattern id="pattern0_1467_38253" patternContentUnits="objectBoundingBox" width="1" height="1">
    <use href="#image0_1467_38253" transform="matrix(0.002251 0 0 0.00298422 -4.32898 -1.10955)"/>
    </pattern>
    <image id="image0_1467_38253"  width="4096" height="2304" href="/mz2.png"/>
    </defs>
  </svg>
  );
};